export type BlinkNoData = { type: 'no_data' };

export type BlinkIncreased = {
    type: 'increased_traffic';
    productName: string | null;
    increasedTraffic: number;
};

export type BlinkLittle = {
    type: 'little_traffic';
    productName: string | null;
};

export type BlinkBumpPlus = {
    type: 'bump_plus';
    extraClicks: number;
};

export type BlinkTraffic = BlinkNoData | BlinkIncreased | BlinkLittle | BlinkBumpPlus;

export const isNoData = (t: BlinkTraffic | null | undefined): t is BlinkNoData => t?.type === 'no_data';
export const isIncreasedTraffic = (t: BlinkTraffic | null | undefined): t is BlinkIncreased =>
    t?.type === 'increased_traffic';
export const isLittleTraffic = (t: BlinkTraffic | null | undefined): t is BlinkLittle => t?.type === 'little_traffic';
export const isBumpPlus = (t: BlinkTraffic | null | undefined): t is BlinkBumpPlus => t?.type === 'bump_plus';
